<template>
    <div class="cmpnt-box page">
        <header class="lmy-header activity-Number">
            <i class="iconfont icon-yuyin" @click="cancel"></i>

            <span class="title">{{title}}</span>
        </header>
        <ul class="optionBox">
            <li v-for="item in dataList" :key="item.value" :class="item.value===active?'activeColor':''" @click="selectData(item)">{{item.lable}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    /**
     * maxCount:最大房间数
     */
    props:['title','active','maxCount'],
    data(){
        return{
            dataList:[],
            // 会议人数
            persionNumList:[
                {value:0,lable:'10-30人'},
                {value:1,lable:'31-60人'},
                {value:2,lable:'61-100人'},
                {value:3,lable:'101-200人'},
                {value:4,lable:'201-300人'},
                {value:5,lable:'301-500人'},
                {value:6,lable:'501-1000人'},
                {value:7,lable:'1000以上'},
            ],
            // 会议预算
            meetPriceData:[
                {value:0,lable:'3千以下'},
                {value:1,lable:'3-5千'},
                {value:2,lable:'5-8千'},
                {value:3,lable:'8千-1.2万'},
                {value:4,lable:'1.2-1.5万'},
                {value:5,lable:'1.5-2万'},
                {value:6,lable:'2-3万'},
                {value:7,lable:'3-5万'},
                {value:8,lable:'5-8万'},
                {value:9,lable:'8-12万'},
                {value:10,lable:'12-20万'},
                {value:11,lable:'20-30万'},
                {value:12,lable:'30万以上'}
            ],
            // 会议类型
            meetTypeData:[
                {value:0,lable:'年会'},
                {value:1,lable:'培训/讲座'},
                {value:2,lable:'工作会/总结会'},
                {value:3,lable:'研讨/交流/论坛'},
                {value:4,lable:'同学会/好友聚会'},
                {value:5,lable:'经销商会议/招商会/推介会'},
                {value:6,lable:'答谢会'},
                {value:7,lable:'团队建设/拓展/休闲会议'},
                {value:8,lable:'发布会/颁奖/庆典'},
                {value:9,lable:'沙龙'},
                {value:10,lable:'Outing/会奖'},
                {value:11,lable:'暂时说不清'}
            ],
            // 会议需求
            meetNeedList:[
                {value:0,lable:'开会'},
                {value:1,lable:'开会 + 用餐'},
                {value:2,lable:'开会 + 住宿'},
                {value:3,lable:'开会 + 用餐 + 住宿'},
            ],
            // 会议场地
            meetingCityList:[
                {value:'香港',lable:'香港'},
                {value:'澳门',lable:'澳门'},
                {value:'北京',lable:'北京'},
                {value:'上海',lable:'上海'},
                {value:'广州',lable:'广州'},
                {value:'深圳',lable:'深圳'},
                {value:'成都',lable:'成都'},
                {value:'武汉',lable:'武汉'},
                {value:'杭州',lable:'杭州'},
                {value:'南京',lable:'南京'},
                {value:'重庆',lable:'重庆'},
                {value:'苏州',lable:'苏州'},
                {value:'西安',lable:'西安'},
                {value:'长沙',lable:'长沙'},
                {value:'天津',lable:'天津'},
                {value:'昆明',lable:'昆明'},
                {value:'青岛',lable:'青岛'},
                {value:'厦门',lable:'厦门'},
                {value:'三亚',lable:'三亚'},
                {value:'郑州',lable:'郑州'},
                {value:'济南',lable:'济南'},
                {value:'沈阳',lable:'沈阳'},
                {value:'佛山',lable:'佛山'},
                {value:'宁波',lable:'宁波'},
                {value:'哈尔滨',lable:'哈尔滨'},
                {value:'东莞',lable:'东莞'},
                {value:'珠海',lable:'珠海'}
            ],
            // 度假目的地
            holidayCityData:[
                {value:'',lable:'不限'},
                {value:'香港',lable:'香港'},
                {value:'澳门',lable:'澳门'},
                {value:'三亚',lable:'三亚'},
                {value:'上海',lable:'上海'},
                {value:'深圳',lable:'深圳'},
                {value:'济南',lable:'济南'},
                {value:'昆明',lable:'昆明'},
                {value:'兰州',lable:'兰州'},
                {value:'南昌',lable:'南昌'},
                {value:'南京',lable:'南京'},
                {value:'青岛',lable:'青岛'},
                {value:'太原',lable:'太原'},
                {value:'天津',lable:'天津'}
            ],
            // 度假类型
            holidayTypeData:[
                {value:'',lable:'不限'},
                {value:'酒店套票',lable:'酒店套票'},
                {value:'旅游度假',lable:'旅游度假'},
                {value:'景区门票',lable:'景区门票'},
                {value:'餐饮美食',lable:'餐饮美食'},
                {value:'市区乐园',lable:'市区乐园'},
                {value:'电影演艺',lable:'电影演艺'},
                {value:'好物商品',lable:'好物商品'},
            ],
            // 抬头类型
            InvoiceTitleList:[
                {value:'0',lable:'单位'},
                {value:'1',lable:'个人'},
            ],
            // 发票项目
            InvoiceItemList:[
                {value:'0',lable:'代订房费'},
                {value:'1',lable:'代订住宿费'}
            ],
            // 房间数
            RoomCountList:[]
        }
    },
    created(){
        if(this.title=='活动人数'){
            this.dataList=this.persionNumList
        }
        else if(this.title=='活动预算'){
            this.dataList=this.meetPriceData
        }
        else if(this.title=='活动类型'){
            this.dataList=this.meetTypeData
        }
        else if(this.title=='活动城市'){
            this.dataList=this.meetingCityList
        }
        else if(this.title=='活动需求'){
            this.dataList=this.meetNeedList
        }
        else if(this.title=='选择目的地'){
            this.dataList=this.holidayCityData
        }
        else if(this.title=='类型'){
            this.dataList=this.holidayTypeData
        }
        else if(this.title=='抬头类型'){
            this.dataList=this.InvoiceTitleList
        }
        else if(this.title=='发票项目'){
            this.dataList=this.InvoiceItemList
        }
        else if(this.title=='房间数'){
            if(this.maxCount){
                for(let i=1;i<=this.maxCount;i++){
                    this.RoomCountList.push({value:i,lable:i+'间'})
                }
            }else{
                for(let i=1;i<=5;i++){
                    this.RoomCountList.push({value:i,lable:i+'间'})
                }
            }
            this.dataList=this.RoomCountList
        }
    },
    methods:{
        cancel(){
            this.$emit('showPage',false)
        },
        selectData(item){
            this.$emit('getSelectData',item,this.title)
            this.$emit('showPage',false)
        }
    }
}
</script>

<style scoped>
    .page{
        background: #fff
    }
    .activity-Number{
        width: 100%;
        height: .88rem;
        line-height: .88rem;
        background: #fff;
        padding: 0 0.3rem ;
        overflow: hidden;
        position: fixed;
        top: 0;
        left: 0;
    }
    .activity-Number .icon-back {
        position: absolute;
        top: 0.05rem;
        font-size: .62rem;
        color: #000;
    }
    .activity-Number .title{
        text-align: center;
        width: 100%;
        display: inline-block;
        height: .88rem;
    }
    ul.optionBox{
        text-align: center;
        margin-top: .88rem
    }
    ul.optionBox li {
        height: .88rem;
        line-height: .88rem;
    }
    ul.optionBox .activeColor{
        color:#2391ff
    }
</style>



// WEBPACK FOOTER //
// src/components/common/cmpnt/selectPage.vue